import styles from "./Campaign.module.scss";
import DatatableComponent from "../../../../../../components/common/DatatableComponent/DatatableComponent";

const Campaign = () => {
  const data = [
    { name: 'Campaign 1', spends: '$5k', sales: '$25k', impr: '500k', clicks: '25k', ctr: '5%', cpc: '0.20', acos: '20%', roas: '5x', status: 'Active' },
    { name: 'Campaign 1', spends: '$5k', sales: '$25k', impr: '500k', clicks: '25k', ctr: '5%', cpc: '0.20', acos: '20%', roas: '5x', status: 'Active' },
    { name: 'Campaign 1', spends: '$5k', sales: '$25k', impr: '500k', clicks: '25k', ctr: '5%', cpc: '0.20', acos: '20%', roas: '5x', status: 'Active' },
    { name: 'Campaign 1', spends: '$5k', sales: '$25k', impr: '500k', clicks: '25k', ctr: '5%', cpc: '0.20', acos: '20%', roas: '5x', status: 'Active' },
    { name: 'Campaign 1', spends: '$5k', sales: '$25k', impr: '500k', clicks: '25k', ctr: '5%', cpc: '0.20', acos: '20%', roas: '5x', status: 'Active' },
  ];

  const columns = [
    { name: 'Campaign name', selector: row => row.name, minWidth: "160px" },
    { name: 'Spends', selector: row => row.spends },
    { name: 'Sales', selector: row => row.sales },
    { name: 'Impr', selector: row => row.impr },
    { name: 'Clicks', selector: row => row.clicks },
    { name: 'CTR', selector: row => row.ctr },
    { name: 'CPC', selector: row => row.cpc },
    { name: 'ACoS', selector: row => row.acos },
    { name: 'ROAS', selector: row => row.roas },
    { name: 'Status', selector: row => row.status },
  ];

  return (
    <section className="mt-2 bg-white">
      <div className={styles.header}>Campaign Performance</div>
      <div className="p-2">
        <DatatableComponent
          columns={columns}
          data={data}
          type="gray"
          bordered
        />
      </div>
    </section>
  );
};

export default Campaign;